var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.task.isCanceling
    ? _c("div", { staticClass: "function-operate" }, [
        _vm.task.status != 2
          ? _c("div", { ref: "optionOperate" }, [
              _vm.task.lowerType != 105
                ? _c("div", { staticClass: "option-operate" }, [
                    _c("div", [
                      _vm.task.status == 0
                        ? _c("div", {
                            staticClass: "operate-menu-btn task-operate-play",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.updateItem(1)
                              }
                            }
                          })
                        : _c("div", {
                            staticClass: "operate-menu-btn",
                            class:
                              _vm.task.type == 2 &&
                              _vm.task.branchType == "realtime"
                                ? "task-operate-pause"
                                : "task-operate-stop",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.updateItem(0)
                              }
                            }
                          })
                    ]),
                    _vm._v(" "),
                    _vm.task.status != 1 ||
                    (_vm.task.type == 2 && _vm.task.branchType == "realtime")
                      ? _c(
                          "div",
                          {
                            staticClass: "operate-menu-btn task-operate-menu",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.changeOptionMenu(true, $event)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isOpenMenu,
                                    expression: "isOpenMenu"
                                  },
                                  {
                                    name: "clickoutside",
                                    rawName: "v-clickoutside",
                                    value: _vm.changeOptionMenu,
                                    expression: "changeOptionMenu"
                                  }
                                ],
                                ref: "operateMenu",
                                staticClass: "operate-menu"
                              },
                              [
                                !(
                                  _vm.task.type == 2 &&
                                  _vm.task.branchType == "realtime" &&
                                  _vm.task.runCount == 0
                                )
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "operate-menu-item",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.openPopup(1)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "icon-util remote-task operate-icon-position"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "operate-menu-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.popup.taskListPopup.viewLogs"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.task.type == 6 && _vm.task.lastLog
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "operate-menu-item",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.openPopup(4)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "icon-util backup-restore-icon operate-icon-position"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "operate-menu-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.cloudExploer.restore"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.task.type == 6 && _vm.task.lastLog
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "operate-menu-item",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.openPopup(5)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "icon-util backup-version-icon operate-icon-position"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "operate-menu-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.cloudBackup.versions"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.task.lowerType != 105
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "operate-menu-item",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.openPopup(2)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "icon-util properties operate-icon-position"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "operate-menu-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "language.common.options"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "operate-menu-item",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.openPopup(3)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "icon-util delete operate-icon-position"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "operate-menu-name" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("language.common.delete")
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _c("div", { staticClass: "option-operate" }, [
                    _c(
                      "button",
                      {
                        staticClass: "white-button",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.openPopup(3)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.common.delete")))]
                    )
                  ])
            ])
          : _c("div", { staticClass: "option-operate" }, [
              _c(
                "button",
                {
                  staticClass: "white-button",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.updateItem(0)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
              )
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aee0d02c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aee0d02c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tab_task_option.vue
// module id = null
// module chunks = 